import { Component, Input, OnInit } from '@angular/core';

/**
 * sticky-note,
 * exclamation-circle,
 * search
 * ranking-star
 */
@Component({
  selector: 'common-subtitle',
  templateUrl: './subtitle.component.html',
  styleUrls: ['./subtitle.component.scss']
})
export class SubtitleComponent implements OnInit {

  @Input() text: string | undefined = '응답 요약'
  @Input() faIcon: string | undefined = 'sticky-note';

  constructor() { }

  ngOnInit(): void {
  }

}
